/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED API METHODS - DO NOT EDIT
 * Generated from: MerchantRedemptionContract
 */

import { apiClient } from '../../utils/api-client';
import { toIsoString } from '@zlinkx/shared-v2';
import type {
  CheckCashierCodeBodyType,
  CheckCashierCodeParamsType,
  CheckCashierCodeResponseType,
  CheckCouponCodeBodyType,
  CheckCouponCodeParamsType,
  CheckCouponCodeResponseType,
  CreateRedemptionBodyType,
  CreateRedemptionParamsType,
  CreateRedemptionResponseType,
  ListRedemptionsParamsType,
  ListRedemptionsQueryType,
  ListRedemptionsResponseType,
  MessageResponse,
} from '@zlinkx/shared-v2';

type SerializableQueryValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;

function serializeQueryValue(value: unknown): string | number | boolean | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (value instanceof Date) {
    return toIsoString(value);
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }

  return String(value);
}

function serializeQueryParams(params?: Record<string, unknown>): Record<string, SerializableQueryValue> | undefined {
  if (!params) {
    return undefined;
  }

  const serialized: Record<string, SerializableQueryValue> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const arrayValues = value
        .map(item => serializeQueryValue(item))
        .filter((item): item is string | number | boolean => item !== undefined);

      if (arrayValues.length > 0) {
        serialized[key] = arrayValues;
      }
      return;
    }

    const scalarValue = serializeQueryValue(value);
    if (scalarValue !== undefined) {
      serialized[key] = scalarValue;
    }
  });

  return Object.keys(serialized).length > 0 ? serialized : undefined;
}

export const merchantredemptionApi = {
  createRedemption: async (
    merchantId: CreateRedemptionParamsType['merchantId'],
    data: CreateRedemptionBodyType
  ): Promise<CreateRedemptionResponseType> => {
    return apiClient.post<CreateRedemptionResponseType['data']>(`/merchants/${merchantId}/redemption/process`, data) as Promise<CreateRedemptionResponseType>;
  },

  listRedemptions: async (
    merchantId: ListRedemptionsParamsType['merchantId'],
    params?: ListRedemptionsQueryType
  ): Promise<ListRedemptionsResponseType> => {
    return apiClient.get<ListRedemptionsResponseType['data']>(`/merchants/${merchantId}/redemption/history`, { params: serializeQueryParams(params) }) as Promise<ListRedemptionsResponseType>;
  },

  checkCashierCode: async (
    merchantId: CheckCashierCodeParamsType['merchantId'],
    data: CheckCashierCodeBodyType
  ): Promise<CheckCashierCodeResponseType> => {
    return apiClient.post<CheckCashierCodeResponseType['data']>(`/merchants/${merchantId}/redemption/validate-cashier`, data) as Promise<CheckCashierCodeResponseType>;
  },

  checkCouponCode: async (
    merchantId: CheckCouponCodeParamsType['merchantId'],
    data: CheckCouponCodeBodyType
  ): Promise<CheckCouponCodeResponseType> => {
    return apiClient.post<CheckCouponCodeResponseType['data']>(`/merchants/${merchantId}/redemption/validate-coupon`, data) as Promise<CheckCouponCodeResponseType>;
  },
};